module.exports = __webpack_public_path__ + "img/4064014710.e81f173c.jpg";